var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40.001,
    viewBox: "0 0 40 40.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32610",
    "data-name": "Group 32610",
    transform: "translate(-740 -430)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 20,
    cy: 20,
    rx: 20,
    ry: 20,
    transform: "translate(740 430)",
    fill: "#ffdada"
  }), /*#__PURE__*/React.createElement("g", {
    id: "mail_2_",
    "data-name": "mail (2)",
    transform: "translate(749 367)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66830",
    "data-name": "Group 66830",
    transform: "translate(0 76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93682",
    "data-name": "Path 93682",
    d: "M18.925,76H1.824A1.826,1.826,0,0,0,0,77.824V88.765a1.826,1.826,0,0,0,1.824,1.824h17.1a1.826,1.826,0,0,0,1.824-1.824V77.824A1.825,1.825,0,0,0,18.925,76Zm-.255,1.216-7.006,6.969a1.824,1.824,0,0,1-2.58,0l-7-6.968ZM1.216,88.518V78.072L6.469,83.3Zm.864.855,5.251-5.218.894.889a3.039,3.039,0,0,0,4.3,0l.9-.89,5.251,5.218Zm17.453-.855L14.279,83.3l5.254-5.226Z",
    transform: "translate(0 -76)",
    fill: "#ff4747"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/IconEmail.7efd9b91.svg";
export { ForwardRef as ReactComponent };